export default __webpack_public_path__ + "static/media/top-box-img.cc528dd2.png";